import { useQuery } from '@tanstack/react-query';
import BigNumber from 'bignumber.js';

import { WEI } from 'ui/shared/value/utils';

// Threshold: wallets with > 1B are considered treasury (locked)
const TREASURY_THRESHOLD = BigNumber('1000000000').times(WEI);

export const useSupplyCalculation = () => {
  return useQuery({
    queryKey: ['supply-calculation'],
    queryFn: async () => {
      const response = await fetch('/node-api/proxy/api/v2/addresses');
      const data = await response.json();

      let totalSupply = BigNumber(0);
      let locked = BigNumber(0);

      data.items.forEach((item: any) => {
        const balance = BigNumber(item.coin_balance || 0);
        totalSupply = totalSupply.plus(balance);

        // If balance > 1B, it's treasury (locked)
        if (balance.isGreaterThan(TREASURY_THRESHOLD)) {
          locked = locked.plus(balance);
        }
      });

      const circulating = totalSupply.minus(locked);

      return {
        totalSupply: totalSupply.toString(),
        circulatingSupply: circulating.toString(),
        nonCirculatingSupply: locked.toString(),
      };
    },
    refetchInterval: 60000,
  });
};
